module.exports = __webpack_public_path__ + "assets/img/two.90abb26a.png";